var dl = require('datalib'),
    u  = {};

dl.extend(u, require('./format'));
module.exports = dl.extend(u, dl);


//////////////////
// WEBPACK FOOTER
// ./~/react-vega/~/vega/src/util/index.js
// module id = 139
// module chunks = 0